import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const CrabAddresses = {
    TOKEN_RING: "0x273131F7CB50ac002BDd08cA721988731F7e1092",
    TOKEN_XRING: "0x7399Ea6C9d35124d893B8d9808930e9d3F211501",
    TOKEN_KTON: "",
    TOKEN_WETH: "0x2D2b97EA380b0185e9fDF8271d1AFB5d2Bf18329",
    ELEMENT_GOLD: "0x701A7d67B824D1Bc713FC5E77bE1C475Ec93106d",
    ELEMENT_WOOD: "0xbA91F2d6d78953881A912f3DF71a541cD30eb980",
    ELEMENT_WATER: "0x54Eb408696E6b3Cc1795Caaf53B22F38F24200Fa",
    ELEMENT_FIRE: "0xEd969c03e8881371754231FE1C8f1D4fE4AF2082",
    ELEMENT_SOIL: "0x9AC045F4B69C2DB58fDF70D4bEF8228ef5A2C5a8",
    GOLD_RUSH_RAFFLE: "",
    PVETEAM_PROXY: "0xe95A32Acf42c10AC45AdbbDDFAd9752Bb51ef609",
    MATERIAL_PROXY: "0x40a61CfBD932395CB81d60E1358af38c0D6bAFf2",
    MATERIALTAKEBACK_PROXY: "0x5781957F2E78B852B05c32B23B0304A6e3d90D53",
    CRAFTBASE_PROXY: "0x894B4B15D1C784E19825f4ddAaF9F339B957B6BD",
    LAND_CLOCK_AUCTION: "0x2e998c97a564D480C83861d9b5c4e0D05b0bdC87",
    APOSTLE_CLOCK_AUCTION: "0x9De583525b19C59c1E8fF4dC601826c27A825e6E",
    SIRING_CLOCK_AUCTION: "0xC9161daEe118BcA99F82AB298D8A3Fc4AdD6118F",
    APOSTLE_BASE: "0x90e2FA4099eb1fED203769B99c9c64cDDa1acB57",
    LAND_RESOURCE: "0x4E319297F77EA8099520F3467a083050090a1d81",
    TOKEN_USE: "0x033FddBB6Bc4DecA422C85e5A5b9Eba4eD0bb7A0",
    OBJECTOWNERSHIP: "0xB29DA7C1b1514AB342afbE6AB915252Ad3f87E4d",
    SETTINGSREGISTRY: "0xb7dc86921bF3e89fC3AF4cDbE8CB65312bdb60da",
    POINTS_REWARD_POOL: "0x9A256C4A039d8C20dcf520dac3FfE08403586265",
    TOKEN_USER_POINTS: "0x013b4f7e1C988d428a2183bCF158D2584F76A6D7",
    FURNACE_TREASURE: "0xeA22f257014B93a95c079C3860f7358b591C502E",
    FURNACE_ITEM_BASE: "0xf4Cfd9517a55BF661f135aa17497D4344DB3a23E",
    FURNACE_TAKEBACK: "0x86DDc0aA1a75b921B6582e0d1523CBc7516C8Dec",
    UNISWAP_EXCHANGE: "0xAF5cAa87a7d3718622604268C43fF6cE9d2cEc3C",
    STAKINGREWARDSFACTORY: "0x554F6311580607DcFaa846Ecf41b3799b58e98a8",
    GOLDRAFFLEPOOL_PROXY: "0x9B6F13184B49d2237B190cb8Bd28373F8DE7258A",
    WOODRAFFLEPOOL_PROXY: "0xCac0864330aC97bF8924005dbC2884638C839734",
    WATERRAFFLEPOOL_PROXY: "0xB8aea9B7A57b82243B74B043905362F4402f2995",
    FIRERAFFLEPOOL_PROXY: "0x12aC25Cc6D2cCe3a89aBC344C8350aCA491a1e42",
    SOILRAFFLEPOOL_PROXY: "0xEa69387AB586Ab01d363bfE44405E0437f229e6C",
};
export const CrabTokens = {
    RING: new Token(ChainId.CRAB, CrabAddresses.TOKEN_RING, 18, "xWRING", "Darwinia Network Native Token"),
    XRING: new Token(ChainId.CRAB, CrabAddresses.TOKEN_XRING, 9, "xRING", "Darwinia Network Native Token"),
    GOLD: new Token(ChainId.CRAB, CrabAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.CRAB, CrabAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.CRAB, CrabAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.CRAB, CrabAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.CRAB, CrabAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.CRAB],
};
